export default __webpack_public_path__ + "static/media/tick-circle.7f62c0f6.svg";